import { BASE_URL } from "../../Constant";

export const API_REGION_UPDATE : string = BASE_URL + '/api/region';
export const API_REGION_LOAD_BY_ID : string = BASE_URL + '/api/region';
export const API_REGION_LOAD_WITH_BUSINESS : string = BASE_URL + '/api/region/loadRegionWithBusiness';
export const API_REGION_SAVE : string = BASE_URL + '/api/region';

